module.exports = __webpack_public_path__ + "static/media/role-on-ec2.f359d35e.png";